import { css } from "styled-components"

export const futuristicListMarker = css`
  position: relative;
  padding-left: 2.1rem;

  &::before {
    content: "";
    position: absolute;
    left: 0.05rem;
    top: 50%;
    width: 1.35rem;
    height: 0.92rem;
    transform: translateY(-50%);
    background: linear-gradient(135deg, #63ffca 0%, #63c3ff 50%, #6a7bff 100%);
    clip-path: polygon(16% 0%, 84% 0%, 100% 50%, 84% 100%, 16% 100%, 0% 50%);
    box-shadow:
      0 0 0 1px rgba(99, 195, 255, 0.22),
      0 10px 22px rgba(26, 88, 147, 0.32);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0.36rem;
    top: 50%;
    width: 0.68rem;
    height: 0.45rem;
    transform: translateY(-50%);
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(159, 206, 255, 0.48));
    clip-path: polygon(16% 0%, 84% 0%, 100% 50%, 84% 100%, 16% 100%, 0% 50%);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
  }
`
